/**
 * Per-site SEO verification meta tag values.
 *
 * Google tokens verified from SFCC Business Manager 2026-04-23.
 * Facebook admins value: HSA only (FSA + WDH have none).
 *
 * Kept separate from seo.config.ts so it can merge cleanly with the
 * per-site seo.config.ts rewrite (SFCC-11156).
 *
 * Consumed by the root Layout <head> to emit:
 *   <meta name="google-site-verification" content="..." />
 *   <meta property="fb:admins" content="..." />   (HSA only)
 */
import type { SiteId } from "~/hec/utils/site-id";

export type SiteVerification = {
  /** google-site-verification meta content value */
  googleVerification: string;
  /** fb:admins meta content value — undefined means don't emit the tag */
  fbAdmins?: string;
};

export const SEO_VERIFICATION: Record<SiteId, SiteVerification> = {
  FSASTORE: {
    googleVerification: "dEOKOH9jX6wPUXta-FfUUcEYyc9GqhyWHghbCt1o-RE",
  },
  HSASTORE: {
    googleVerification: "Sp-Iz8timiM_o_VHuBsTrWECVuc-mmBbtwMOWPFE1K8",
    fbAdmins: "232066183646752",
  },
  WDH: {
    googleVerification: "rPmsijfahHpFz0Pl9WpxC1JilLKVASDgwq3v0tJhd-w",
  },
};
